import React from 'react';

import UpgradeRecruiterAccount from 'scenes/Dialog/components/UpgradeRecruiterAccount';
import LinkButton from 'components/LinkButton';

import { DateHelpers } from 'helpers/date-helpers';
import { ROUTE } from 'constants/route';
import { UPGRADE_ACCOUNT_TYPE } from 'constants/upgrade-account-types';

import './styles.css';

const ProfileItemTestResults = props => {
  const {
    user,
    history,
    data: { Date, Percentile, Score },
    showPercentile = false,
  } = props;

  const handleUpgrade = () => {
    if (UPGRADE_ACCOUNT_TYPE.RECRUITER === user.accountUpgradeType) {
      UpgradeRecruiterAccount();
    } else {
      history.push(ROUTE.CANDIDATE_UPGRADE_PREMIUM, {
        returnUrl: window.location.pathname,
      });
    }
  };

  return (
    <div className="profile-item-test-result">
      <div className="profile-item-test-result__date">
        Test date:{' '}
        <span className="profile-item-test-result__text">
          {DateHelpers.getMonthNameDayYearFormat(Date)}
        </span>
      </div>
      <div className="profile-item-test-result__score">
        Score: <span className="profile-item-test-result__text">{Score}</span>
      </div>
      <div className="profile-item-test-result__percentile">
        Percentile:{' '}
        {showPercentile ? (
          <span className="profile-item-test-result__text">
            {`Top `}
            {Percentile}
            {`%`}
          </span>
        ) : (
          <div className="profile-item-test-result__text profile-item-test-result__text--message">
            <div>
              <LinkButton
                btnFontWeight={400}
                controlFunc={handleUpgrade}
                text="Upgrade To Premium"
              />
            </div>
            <div>to see the Percentile</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfileItemTestResults;
